import React, { useEffect, useState } from "react";
import axios from "axios";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import { useSelector, useDispatch } from "react-redux";
import {
  Snackbar, Alert
} from "@mui/material";
import {
  setSelectedAlert,
  setDeletePopup,
  setSelectAllAlerts,
  setMultiEditPopup,
  setSelectedRows,
  setAddPopup,
  setAddMultyPopup,
  setEditPopup,
} from "features/alert/alertSlice";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import Checkbox from "@mui/material/Checkbox";
import { deleteAlertConfiguration } from "config/apis";
import { fetchAlertConfigDetails } from "features/alert/alertThunk";

function AlertTable() {
  const dispatch = useDispatch();
  const alertData = useSelector((state) => state.alerts.alertData);
  const toggle = useSelector((state) => state.alerts.toggle);
  const selectedRows = useSelector((state) => state.alerts.selectedRows);
  const vehicleSearch = useSelector((state) => state.alerts.vehicleSearch);

  const kmhToKnots = (kmh) => {
    if (kmh === "" || kmh === null || kmh === undefined) return "";

    return Math.round(Number(kmh) * 0.539957);
  };

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  console.log("alertdata", alertData);


  const handleOpen = (row) => {
    dispatch(setAddPopup(true));
    dispatch(setSelectedAlert(row));
  };

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const handleEditOpen = (row) => {
    dispatch(setEditPopup(true));
    dispatch(setSelectedAlert(row));
  };

  const handleDelete = (row) => {
    dispatch(setDeletePopup(true));
    dispatch(setSelectedAlert(row));
  };

  const handleMultipleDelete = async () => {
    try {
      const token = localStorage.getItem("token");

      if (!token) {
        console.error("❌ No token found in localStorage");
        return;
      }

      if (!selectedRows.length) return;

      let successMessages = [];
      let failMessages = [];

      await Promise.all(
        selectedRows.map(async (row) => {
          try {
            const alert = alertData.find(
              (item) => item.thingId === row.thingId
            );

            if (!alert) {
              failMessages.push(`Alert not found for ${row.thingId}`);
              return;
            }

            const payload = {
              thingIds: [alert.thingId],
              alertId: alert.alertId, // ✅ convert to number
            };

            const response = await axios.post(
              deleteAlertConfiguration,
              payload,
              {
                headers: {
                  "x-dhundhoo-session": token,
                },
              }
            );

            const result = response.data;

            if (result?.responseCode === 200) {
              successMessages.push(result?.message);
            } else {
              failMessages.push(result?.message || `Failed for ${row.thingId}`);
            }
          } catch (error) {
            failMessages.push(`Error deleting ${row.thingId}`);
            console.error(
              `❌ Error deleting alert for ${row.thingId}:`,
              error.message
            );
          }
        })
      );

      console.log("🎉 Multiple delete complete");

      // ✅ Show backend success messages
      if (successMessages.length > 0) {
        setSnackbar({
          open: true,
          message: successMessages.join(" | "), // 👈 show backend messages
          severity: "success",
        });
      }

      // ✅ Show failure messages (if any)
      if (failMessages.length > 0) {
        setSnackbar({
          open: true,
          message: failMessages.join(" | "),
          severity: "error",
        });
      }
      await dispatch(fetchAlertConfigDetails(alert?.alertId));


    } catch (error) {
      console.error("❌ Error deleting alerts:", error);

      setSnackbar({
        open: true,
        message: "Error deleting alerts",
        severity: "error",
      });
    }
  };



  useEffect(() => {
    dispatch(setSelectAllAlerts(selectedRows));
  }, [selectedRows, dispatch]);

  const handleCheckboxChange = (row) => {
    if (selectedRows.some((r) => r.thingId === row.thingId)) {
      dispatch(
        setSelectedRows(selectedRows.filter((r) => r.thingId !== row.thingId))
      );
    } else {
      dispatch(
        setSelectedRows([
          ...selectedRows,
          { thingId: row.thingId, alertEnable: row.alertEnable },
        ])
      );
    }
  };

  const handleSelectAll = () => {
    // Sirf wahi rows select hongi jo current view (toggle) mein hain
    const filteredRows = alertData
      .filter((row) => Boolean(row.alertEnable) === toggle)
      .map((row) => ({
        thingId: row.thingId,
        alertEnable: row.alertEnable,
      }));

    if (selectedRows.length === filteredRows.length) {
      dispatch(setSelectedRows([]));
    } else {
      dispatch(setSelectedRows(filteredRows));
    }
  };

  const handleMultyEdit = () => {
    dispatch(setMultiEditPopup(true));
  };

  const handleAddMultiple = () => {
    dispatch(setAddMultyPopup(true));
  };

  return (
    <MDBox sx={{ mt: "2rem" }}>
      {selectedRows.length > 0 && toggle && (
        <MDBox display="flex" justifyContent="flex-end" gap={1} mb={2}>
          <MDButton variant="contained" color="info" onClick={handleMultyEdit}>
            Edit Multiple
          </MDButton>
          <MDButton
            variant="contained"
            color="error"
            onClick={handleMultipleDelete}
          >
            Delete Multiple
          </MDButton>
        </MDBox>
      )}
      {selectedRows.length > 0 && !toggle && (
        <MDBox display="flex" justifyContent="flex-end" gap={1} mb={2}>
          <MDButton
            variant="contained"
            color="info"
            onClick={handleAddMultiple}
          >
            Multiple vehicle
          </MDButton>
        </MDBox>
      )}

      <MDBox
        component="table"
        sx={{
          width: "100%",
          borderCollapse: "collapse",
          boxShadow: 2,
          borderRadius: "12px",
          overflow: "hidden",
        }}
      >
        <MDBox
          component="thead"
          sx={{ backgroundColor: "#1398DC", color: "#fff" }}
        >
          <MDBox component="tr">
            <MDBox
              component="th"
              sx={{ padding: "12px 16px", borderBottom: "1px solid #ddd" }}
            >
              <Checkbox
                checked={
                  selectedRows.length > 0 &&
                  selectedRows.length ===
                  alertData.filter((row) => Boolean(row.alertEnable) === toggle).length
                }
                indeterminate={
                  selectedRows.length > 0 &&
                  selectedRows.length <
                  alertData.filter((row) => Boolean(row.alertEnable) === toggle).length
                }
                onChange={handleSelectAll}
                sx={{ color: "white" }}
              />
            </MDBox>
            {["Vehicle No", "Value (knots)", "Email", "Start Time", "End Time", "Action"].map(
              (header) => (
                <MDBox
                  component="th"
                  key={header}
                  sx={{
                    textAlign: "left",
                    padding: "12px 16px",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <MDTypography
                    variant="button"
                    fontWeight="bold"
                    color="white"
                  >
                    {header}
                  </MDTypography>
                </MDBox>
              )
            )}
          </MDBox>
        </MDBox>
        <MDBox component="tbody">
          {Array.isArray(alertData) && alertData.length > 0 ? (
            alertData
              .filter((row) => {
                // Strict Status Check: Alert status matches toggle switch
                const isCorrectStatus = Boolean(row.alertEnable) === toggle;

                // Search Filter: Checks thingId against search input
                const searchValue = vehicleSearch?.value || vehicleSearch || "";
                const matchesSearch = !searchValue ||
                  (row.thingId &&
                    row.thingId.toString().toLowerCase().includes(searchValue.toString().toLowerCase()));

                return isCorrectStatus && matchesSearch;
              })
              .map((row, idx) => (
                <MDBox
                  component="tr"
                  key={idx}
                  sx={{
                    "&:nth-of-type(odd)": { backgroundColor: "#fafafa" },
                    "&:hover": { backgroundColor: "#f0f0f0" },
                  }}
                >
                  <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    <Checkbox
                      checked={selectedRows.some(
                        (r) => r.thingId === row.thingId
                      )}
                      onChange={() => handleCheckboxChange(row)}
                    />
                  </MDBox>

                  <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    <MDTypography variant="body2">{row.thingId}</MDTypography>
                  </MDBox>
                  <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    <MDTypography variant="body2">
                      {kmhToKnots(row.alertValue)}
                    </MDTypography>
                  </MDBox>
                  <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    {Array.isArray(row.emailId) &&
                      row.emailId.map((email, i) => (
                        <MDTypography key={i} variant="body2">
                          {email}
                        </MDTypography>
                      ))}
                  </MDBox>
                  {/* <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    {Array.isArray(row.mobileNumber) &&
                      row.mobileNumber.map((phone, i) => (
                        <MDTypography key={i} variant="body2">
                          {phone}
                        </MDTypography>
                      ))}
                  </MDBox> */}
                  <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    <MDTypography variant="body2">
                      {row.startTime}
                    </MDTypography>
                  </MDBox>
                  <MDBox component="td" sx={{ padding: "12px 16px" }}>
                    <MDTypography variant="body2">
                      {row.endTime}
                    </MDTypography>
                  </MDBox>
                  <MDBox
                    component="td"
                    sx={{ padding: "12px 16px", display: "flex" }}
                  >
                    {toggle === true ? (
                      <>
                        <MDBox
                          onClick={() => handleEditOpen(row)}
                          sx={{ cursor: "pointer", color: "green", mr: 1 }}
                        >
                          <EditIcon />
                        </MDBox>
                        <MDBox
                          sx={{ cursor: "pointer", color: "red" }}
                          onClick={() => handleDelete(row)}
                        >
                          <DeleteIcon />
                        </MDBox>
                      </>
                    ) : (
                      <MDBox
                        sx={{ cursor: "pointer" }}
                        onClick={() => handleOpen(row)}
                      >
                        <AddIcon />
                      </MDBox>
                    )}
                  </MDBox>
                </MDBox>
              ))
          ) : (
            <MDBox component="tr">
              <MDBox
                component="td"
                colSpan={6}
                sx={{ textAlign: "center", py: 2 }}
              >
                <MDTypography variant="body2" color="textSecondary">
                  No alerts found
                </MDTypography>
              </MDBox>
            </MDBox>
          )}
        </MDBox>
      </MDBox>
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={handleSnackbarClose}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </MDBox>
  );
}

export default AlertTable;